import { Phone } from 'lucide-react';

import { APP_URL } from '@marketing/data/nav';
import { LumeMark } from '@marketing/illustrations/LumeMark';

// ============================================================
// FooterInstitutional — links + emergência + aviso CFM
// ============================================================

const emergencyPhones = [
  { num: '188', label: 'CVV — Centro de Valorização da Vida (24h)', tel: 'tel:188' },
  { num: '192', label: 'SAMU — Urgência médica', tel: 'tel:192' },
  { num: '100', label: 'Disque-100 — Direitos humanos', tel: 'tel:100' },
  { num: '180', label: 'Central de Atendimento à Mulher', tel: 'tel:180' },
  { num: '190', label: 'Polícia Militar', tel: 'tel:190' },
];

export function FooterInstitutional() {
  return (
    <footer
      id="footer"
      className="lume-footer"
      aria-labelledby="footer-title"
    >
      <div className="lume-container">
        <h2 id="footer-title" className="lume-sr-only" style={{ position: 'absolute', left: '-9999px' }}>
          Rodapé institucional
        </h2>

        <div className="lume-footer__grid">
          <div className="lume-stack lume-stack-md">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <LumeMark size={36} />
              <span
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  letterSpacing: '-0.02em',
                  color: 'var(--color-brand-900)',
                }}
              >
                lume
              </span>
            </div>
            <p
              style={{
                margin: 0,
                fontSize: '0.9rem',
                color: 'var(--color-fg-muted)',
                maxWidth: '24rem',
                lineHeight: 1.55,
              }}
            >
              O Programa <strong>TEACare</strong> desenvolveu o aplicativo <strong>Lume</strong>{' '}
              para acompanhamento contínuo do TEA no SUS.
            </p>
            <p
              style={{
                margin: 0,
                fontSize: '0.8rem',
                color: 'var(--color-fg-subtle)',
              }}
            >
              CNPJ a ser publicado · Programa de pesquisa em saúde digital
            </p>
          </div>

          <div className="lume-footer__col">
            <h3>Aplicação</h3>
            <ul className="lume-footer__list">
              <li>
                <a href={APP_URL}>app.lume.med.br</a>
              </li>
              <li>
                <a href="https://lume.med.br">lume.med.br</a>
              </li>
              <li>
                <a href="#showcase">Telas reais</a>
              </li>
              <li>
                <a href="#parceria">Falar com a equipe</a>
              </li>
            </ul>
          </div>

          <div className="lume-footer__col">
            <h3>Conformidade</h3>
            <ul className="lume-footer__list">
              <li>
                <a href="#conformidade">LGPD · CFM 2.314 · ANVISA</a>
              </li>
              <li>
                <a href="/docs/RIPD-v1.pdf">RIPD v1 (PDF)</a>
              </li>
              <li>
                <a href="/docs/TCLE-TALE.pdf">TCLE / TALE (PDF)</a>
              </li>
              <li>
                <a href="/docs/politica-privacidade.html">Política de privacidade</a>
              </li>
            </ul>
          </div>

          <div className="lume-footer__col">
            <h3>Programa TEACare</h3>
            <ul className="lume-footer__list">
              <li>
                <a href="#manifesto">Manifesto</a>
              </li>
              <li>
                <a href="#ciencia">Ciência</a>
              </li>
              <li>
                <a href="#roadmap">Estado atual</a>
              </li>
              <li>
                <a href="mailto:contato@lume.med.br">contato@lume.med.br</a>
              </li>
            </ul>
          </div>
        </div>

        <aside className="lume-emergency" aria-labelledby="emergency-title">
          <h3 id="emergency-title" className="lume-emergency__title">
            <Phone
              size={18}
              aria-hidden="true"
              style={{ display: 'inline', verticalAlign: 'text-bottom', marginRight: 8 }}
            />
            Em emergência, ligue agora — não aguarde a equipe TEACare
          </h3>
          <ul
            role="list"
            style={{
              listStyle: 'none',
              margin: '0.5rem 0 0',
              padding: 0,
              display: 'grid',
              gap: '0.5rem',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              fontSize: '0.92rem',
            }}
          >
            {emergencyPhones.map((p) => (
              <li key={p.num}>
                <a href={p.tel}>
                  <strong>{p.num}</strong>
                </a>
                <span style={{ color: 'inherit', opacity: 0.85 }}> — {p.label}</span>
              </li>
            ))}
          </ul>
          <p
            style={{
              margin: '1rem 0 0',
              fontSize: '0.85rem',
              fontWeight: 600,
              padding: '0.6rem 0.85rem',
              background: 'rgba(255,255,255,0.45)',
              borderRadius: '0.5rem',
            }}
          >
            Este aplicativo NÃO substitui consulta médica. Em emergência ligue 192 (SAMU) ou vá ao
            serviço de urgência mais próximo.
          </p>
        </aside>

        <div
          style={{
            marginTop: '2rem',
            paddingTop: '1.5rem',
            borderTop: '1px solid var(--color-border-default)',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1rem',
            justifyContent: 'space-between',
            fontSize: '0.8rem',
            color: 'var(--color-fg-subtle)',
          }}
        >
          <span>© {new Date().getFullYear()} Programa TEACare · Todos os direitos reservados.</span>
          <span>
            Construído com cuidado para o SUS · Hospedado em Google{' '}
            <code style={{ fontSize: 'inherit' }}>southamerica-east1</code>
          </span>
        </div>
      </div>
    </footer>
  );
}
